import PrepaidCardSaleApi from '@apis/prepaid/PrepaidCardSaleApi';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import { datadogRum } from '@datadog/browser-rum';
import useFingerPay from '@hooks/order/useFingerPay';
import useToast from '@hooks/ui/useToast';
import useProjectId from '@hooks/useProjectId';
import { ErrorResponse } from '@models/error';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

function usePrepaidCharge(id: string) {
  const { amount } = useContext(PrepaidContext);
  const toast = useToast();
  const projectId = useProjectId();
  const openFingerPay = useFingerPay();

  const { mutate } = useMutation({
    mutationFn: () => PrepaidCardSaleApi.registerCharge(id, {
      projectId,
      amount: amount * 10000,
      payMethodType: 'CREDIT_CARD',
    }),
    onSuccess(res) {
      const {
        checkoutUrl, orderNo, mallId, requestedAt, hashString,
      } = res;
      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      } else if (orderNo && mallId && requestedAt && hashString) {
        openFingerPay({
          orderNo,
          mallId,
          requestedAt,
          hashString,
          paymentAmount: amount * 10000,
          itemName: `선불카드 충전 ${(amount * 10000).toLocaleString()}원`,
          returnUri: '/prepaid-card/payment/finger-pay',
        });
      }
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '오류가 발생하였습니다. 다시 시도해주세요.');
    },
  });
  const handleCharge = () => {
    if (import.meta.env.MODE !== 'development') {
      datadogRum.addAction('prepaidCardChargeCheckout', {
        amount,
      });
    }
    mutate();
  };

  return { handleCharge };
}

export default usePrepaidCharge;
